// Simplified RTSP-WebRTC adapter that falls back to WebRTC
import { createWebrtcAdapter } from './webrtc.js';

export function createRTSPWebRTCVideoAdapter(src) {
  // For now, we'll convert RTSP-WebRTC to regular WebRTC
  // In a full implementation, this would handle RTSP to WebRTC conversion
  
  // Convert RTSP URL to WebRTC URL if needed
  let webrtcUrl = src.url;
  if (src.rtspUrl) {
    // This should be handled by your backend to convert RTSP to WebRTC
    webrtcUrl = src.serverUrl || src.url;
  }
  
  const webrtcSource = {
    type: 'webrtc',
    url: webrtcUrl,
    token: src.token
  };
  
  return createWebrtcAdapter(webrtcSource);
}
